export const DISABLED_PEOPLE_ADAPTED_FEATURE_ID = 1;
export const IS_ADAPTED_MAMMOGRAPH_FEATURE_ID = 2;